// @core/api/endpoints/subscription/update_subscription_item.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SubscriptionItemResponse,
  UpdateSubscriptionItemRequest,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Update subscription item
 * Updates a subscription line item, such as changing seat quantity or metered pricing.
 */
export async function UpdateSubscriptionItem(
  subscription_id: string,
  item_id: string,
  data: UpdateSubscriptionItemRequest,
  options?: RequestOptions
): Promise<SubscriptionItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id/items/:item_id`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  requestPath = requestPath.replace(':item_id', encodeURIComponent(item_id));
  const requestOptions = options;
  return client.put<SubscriptionItemResponse>(requestPath, data, requestOptions);
}
